import type { IButtonProps } from "@similarweb/ui-components";
import { Button } from "@similarweb/ui-components";
import type { FC } from "react";
import { useCallback } from "react";
import type { HookType } from "app/services/ModalService";
import { openHooksModalV5 } from "app/services/ModalService";
import styled from "styled-components";

import { i18nFilter } from "app/filters/i18nFilter";

interface IUnlockModalV2Container {
    buttonConfig?: IButtonProps;
    buttonText?: string;
    className?: string;
    isLink?: boolean;
    modalConfig: {
        featureKey: string;
        location?: HookType;
    };
}

const UnlockLink = styled.a`
    cursor: pointer;
`;

const UnlockModalV2Container: FC<IUnlockModalV2Container> = ({
    isLink,
    className,
    buttonText,
    buttonConfig,
    modalConfig: { featureKey, location },
}) => {
    const label = i18nFilter()(buttonText);
    const openModal = useCallback(() => {
        openHooksModalV5(featureKey, location);
    }, [featureKey, location]);

    return (
        <div>
            {!isLink ? (
                <Button
                    {...buttonConfig}
                    className={className}
                    onClick={openModal}
                >
                    {label}
                </Button>
            ) : (
                <UnlockLink
                    onClick={openModal}
                    className={className}
                >
                    {label}
                </UnlockLink>
            )}
        </div>
    );
};

export default UnlockModalV2Container;
